import Seo, { breadcrumbSchema } from "@/lib/seo";
import PageHero from "@/components/PageHero";
import ServicesGrid from "@/components/sections/ServicesGrid";
import Approach from "@/components/sections/Approach";
import CTASection from "@/components/CTASection";
import { IMAGES } from "@/data/site";

export default function Services() {
  return (
    <>
      <Seo
        title="Services"
        description="Explore SKY's safety consultancy and training services: WSH Consultancy, Fire Safety Consultancy, WSH Training, Fire Safety Training, Corporate Safety Programmes and Safety Performance Improvement."
        path="/services"
        schema={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])}
      />
      <PageHero
        eyebrow="Our Services"
        title="Comprehensive Safety Consultancy & Training"
        description="Six specialised areas covering workplace safety, fire safety, emergency preparedness and practical training — tailored to your organisation."
        image={IMAGES.riskAssessment}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]}
      />
      <ServicesGrid withHeading={false} />
      <Approach />
      <CTASection />
    </>
  );
}
